"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProblemDescriptionTypeCodeMapping = exports.ProblemTypeDescription = exports.ProblemTypeCode = void 0;
var ProblemTypeCode;
(function (ProblemTypeCode) {
    ProblemTypeCode[ProblemTypeCode["Error"] = 1] = "Error";
    ProblemTypeCode[ProblemTypeCode["Warning"] = 2] = "Warning";
    ProblemTypeCode[ProblemTypeCode["RequiresReview"] = 3] = "RequiresReview";
    ProblemTypeCode[ProblemTypeCode["Info"] = 4] = "Info";
    ProblemTypeCode[ProblemTypeCode["Suspense"] = 5] = "Suspense";
})(ProblemTypeCode = exports.ProblemTypeCode || (exports.ProblemTypeCode = {}));
var ProblemTypeDescription;
(function (ProblemTypeDescription) {
    ProblemTypeDescription["Error"] = "error";
    ProblemTypeDescription["Info"] = "info";
    ProblemTypeDescription["Suspense"] = "suspense";
    ProblemTypeDescription["RequiresReview"] = "requires review";
    ProblemTypeDescription["Warning"] = "warning";
})(ProblemTypeDescription = exports.ProblemTypeDescription || (exports.ProblemTypeDescription = {}));
exports.ProblemDescriptionTypeCodeMapping = (_a = {},
    _a[ProblemTypeDescription.Error] = ProblemTypeCode.Error,
    _a[ProblemTypeDescription.Warning] = ProblemTypeCode.Warning,
    _a[ProblemTypeDescription.RequiresReview] = ProblemTypeCode.RequiresReview,
    _a[ProblemTypeDescription.Info] = ProblemTypeCode.Info,
    _a[ProblemTypeDescription.Suspense] = ProblemTypeCode.Suspense,
    _a);
